import { useCallback } from 'preact/hooks';

type ViewToggleProps = {
	mode: 'map' | 'list';
	setMode: ( mode: 'map' | 'list' ) => void;
};

/**
 * ViewToggle component.
 * Radio button group to switch between map and list views.
 * Hidden on mobile where only the list view is shown.
 *
 * @param {Object}   props         - Component props.
 * @param {string}   props.mode    - Current display mode.
 * @param {Function} props.setMode - Callback to update the display mode.
 * @return {*} jsx
 */
export default function ViewToggle( { mode, setMode }: ViewToggleProps ) {
	const handleChange = useCallback(
		( e: Event ) => {
			const value = ( e.target as HTMLInputElement ).value as 'map' | 'list';
			setMode( value );
		},
		[ setMode ]
	);

	return (
		<div className="str-maps__view-toggle">
			<fieldset>
				<legend className="screen-reader-text">Toggle between map and list view</legend>
				<label htmlFor="str-maps-view-mode-map" className={ mode === 'map' ? 'is-active' : '' }>
					<input
						type="radio"
						id="str-maps-view-mode-map"
						name="str-maps-view-mode"
						value="map"
						checked={ mode === 'map' }
						onChange={ handleChange }
					/>
					<span>Map</span>
				</label>
				<label htmlFor="str-maps-view-mode-list" className={ mode === 'list' ? 'is-active' : '' }>
					<input
						type="radio"
						id="str-maps-view-mode-list"
						name="str-maps-view-mode"
						value="list"
						checked={ mode === 'list' }
						onChange={ handleChange }
					/>
					<span>List</span>
				</label>
			</fieldset>
		</div>
	);
}
